import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { textProps } from "../props/text";
/** @public */ export const textNodeProps = {
    text: textProps,
    // Allows you optionally override the default localization key (which is the
    // value of the string)
    localizationKey: T.optional(T.string)
};
/** @internal */ export const textNodeMigrations = defineMigrations({});
export const TextNodeInfo = {
    migrations: textNodeMigrations,
    props: textNodeProps,
    meta: {}
};
